import { Badge, CircularProgress } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { DisclosureHost } from "../../../../hooks/use-disclosure";
import Flex from "../../../Flex";
import { ScrollArea } from "../../../ScrollBar";
import SideSheetDrawer from "../../../SidesheetDrawer";
import CustomTabs from "../../CustomTabs";
import NotificationCardView from "./NotificationCardView";
import LinkButton from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/patient-chronological-records-and-requiring-actions/LinkButton";

type NotificationDrawerProps = {
  onTabChange: () => void;
  notificationCount?: number;
  activeTab?: string;
  setActiveTab: Dispatch<SetStateAction<string>>;
  disclosureHost: DisclosureHost;
  allNotifications?: any;
  onRead: (id: string, ind: number) => void;
  fetchMoreOnBottomReached: (e: any) => void;
  isLoading: boolean;
  onMarkAllRead: () => void;
};

const NotificationDrawer = ({
  onTabChange,
  notificationCount,
  activeTab,
  setActiveTab,
  disclosureHost,
  allNotifications,
  onRead,
  fetchMoreOnBottomReached,
  isLoading,
  onMarkAllRead,
}: NotificationDrawerProps) => {
  return (
    <SideSheetDrawer
      title="Notifications"
      w="440px"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      endIcon={
        activeTab !== "read" && (
          <Badge
            max={MAX_COUNT}
            badgeContent={notificationCount}
            sx={{
              "& .MuiBadge-badge": {
                mr: 2,
                fontSize: "11px",
                backgroundColor: "#E1FCDE",
                color: "#049B22",
              },
            }}
          />
        )
      }
    >
      <Flex flexDirection={"column"} gap={1}>
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <CustomTabs
            value={activeTab}
            tabsData={[
              { value: "unRead", label: "Unread" },
              { value: "read", label: "Read" },
              { value: "all", label: "All" },
            ]}
            onChange={(v) => {
              onTabChange();
              setActiveTab(v);
            }}
          />
          {activeTab !== "read" && (
            <LinkButton underLineOnHover onClick={onMarkAllRead}>
              Mark All As Read
            </LinkButton>
          )}
        </Flex>
        <ScrollArea
          height={"84vh"}
          // mt={2}
          pr={0.5}
          onScroll={(e) => fetchMoreOnBottomReached(e.target)}
        >
          <Flex flexDirection={"column"} gap={1.5}>
            {allNotifications?.map((it: any, ind: number) => {
              return (
                <NotificationCardView
                  key={it?.uuid}
                  notifyData={it}
                  onRead={() => onRead(it.uuid, ind)}
                />
              );
            })}
          </Flex>
          {isLoading && (
            <Flex width={"100%"} justifyContent={"center"}>
              <CircularProgress />
            </Flex>
          )}
        </ScrollArea>
      </Flex>
    </SideSheetDrawer>
  );
};

export default NotificationDrawer;

const MAX_COUNT = 9999;
